/* src/app/system-view/main-dashboard/chart-card/chart-card-configuration/chart-card-configuration.component.scss */
.configuration-fields {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  position: relative;
}
form {
  display: flex;
  flex-direction: column;
  height: 100%;
  margin: var(--tem-space-3);
  gap: var(--tem-space-3);
}
nz-form-item {
  width: 100%;
  margin-bottom: var(--tem-space-2);
}
.content {
  position: relative;
  display: flex;
  flex-direction: column;
  font-size: var(--tem-fs-sm);
  gap: var(--tem-space-3);
}
.avancado-detail {
  padding-top: var(--tem-space-2);
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}
.avancado-detail__field {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  margin-bottom: 0;
}
.avancado-detail__control {
  flex: 1;
  min-height: 0;
}
.avancado-detail__control ::ng-deep .ant-form-item-control-input,
.avancado-detail__control ::ng-deep .ant-form-item-control-input-content {
  height: 100%;
}
.avancado-detail__textarea {
  height: 100%;
  min-height: 240px;
  resize: none;
  font-family:
    "Consolas",
    "Menlo",
    monospace;
  font-size: var(--tem-fs-sm);
}
.float-menu-format {
  right: 25px;
  position: absolute;
  bottom: 10px;
  z-index: 10;
  color: var(--tem-warn);
}
/*# sourceMappingURL=chart-card-configuration.component.css.map */
